import { render } from "./CarrierLogos.vue?vue&type=template&id=f5c5ef14&scoped=true"
import script from "./CarrierLogos.vue?vue&type=script&lang=js"
export * from "./CarrierLogos.vue?vue&type=script&lang=js"

import "./CarrierLogos.vue?vue&type=style&index=0&id=f5c5ef14&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5c5ef14"]])

export default __exports__